import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router';
import { onClickFullEpisodeBackCatalogGatedCard } from 'redux/modules/mixpanel';
import { pushModal } from 'redux/modules/modal';
import { isBasicOrFreeSelector } from 'redux/modules/pricing';
import { autogramWizardLocation } from 'utils/routes';
import SourceCardOptions from './SourceCardOptions';
import { SourceStepType } from './types';

interface SourceStepProps {
  onClick: (selected: SourceStepType) => void;
}

const SourceStep: React.FC<SourceStepProps> = ({ onClick }) => {
  const dispatch = useDispatch();
  const isFreeTier = useSelector(isBasicOrFreeSelector);
  const history = useHistory();

  const handleBackCatalogClick = useCallback((): void => {
    history.push(autogramWizardLocation());
  }, [history]);

  const handleUpgradeToUnlockClick = useCallback((): void => {
    dispatch(onClickFullEpisodeBackCatalogGatedCard());
    dispatch(
      pushModal({
        name: 'BackCatalogUpsell',
      }),
    );
  }, [dispatch]);

  const handleManualCreationClick = useCallback((): void => {
    onClick('ManualCreation');
  }, [onClick]);

  return (
    <SourceCardOptions
      isFreeTier={isFreeTier}
      onBackCatalogClick={
        isFreeTier ? handleUpgradeToUnlockClick : handleBackCatalogClick
      }
      onManualCreationClick={handleManualCreationClick}
    />
  );
};

export default SourceStep;
